// extracted by mini-css-extract-plugin
export default {"root":"Error_root__9pacq","icon":"Error_icon__Z2-Z7","error":"Error_error__94Mlh"};